import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";

export default function ReimpostaPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", conferma_password: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 8) {
      setError("La password deve contenere almeno 8 caratteri");
      return;
    }
    if (form.password !== form.conferma_password) {
      setError("Le password non coincidono");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, ...form });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err, "Link non valido o scaduto. Richiedi un nuovo link."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16 sm:px-6 animate-fade-up" data-testid="reimposta-password-page">
      <div className="card-elegant">
        <h1 className="font-heading text-2xl font-bold text-bordeaux-dark sm:text-3xl">Reimposta password</h1>
        <p className="mt-2 text-sm text-muted-foreground">Scegli la nuova password per il tuo account ENPALSBOX.</p>

        {error && (
          <div data-testid="reimposta-error" className="mt-4 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error}
          </div>
        )}

        {!token ? (
          <div data-testid="reimposta-no-token" className="mt-6 space-y-4">
            <div className="rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
              Link non valido: manca il codice di reimpostazione.
            </div>
            <p className="text-center text-sm text-muted-foreground">
              <Link to="/recupera-password" data-testid="reimposta-richiedi-link" className="font-semibold text-bordeaux hover:underline">
                Richiedi un nuovo link
              </Link>
            </p>
          </div>
        ) : done ? (
          <div data-testid="reimposta-success" className="mt-6 space-y-4">
            <div className="rounded-lg border border-green-300 bg-green-50 px-4 py-3 text-sm text-green-800">
              Password aggiornata correttamente. Ora puoi accedere con la nuova password.
            </div>
            <Link to="/accedi" data-testid="reimposta-login-button" className="btn-bordeaux w-full">
              VAI AL LOGIN
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} noValidate className="mt-6 space-y-5" data-testid="reimposta-form">
            <div>
              <label className="label-elegant" htmlFor="reimposta-password">Nuova password</label>
              <input id="reimposta-password" type="password" data-testid="reimposta-password-input" className="input-elegant" required
                value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
            <div>
              <label className="label-elegant" htmlFor="reimposta-conferma">Conferma password</label>
              <input id="reimposta-conferma" type="password" data-testid="reimposta-conferma-input" className="input-elegant" required
                value={form.conferma_password} onChange={(e) => setForm({ ...form, conferma_password: e.target.value })} />
            </div>
            <button type="submit" disabled={loading} data-testid="reimposta-submit-button" className="btn-bordeaux w-full">
              {loading ? "SALVATAGGIO..." : "SALVA NUOVA PASSWORD"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
